import { FormContent } from '../../../components/bookingConfirmationCard/bookingConfirmationFun';

const AccPercentage = ({ accDetails = { accDetails } }) => {
    return (
        <div>
            <h2 className='orgAccountH2'>Percentage Details</h2>
            <div className='orgAccountSecDiv'>
                <div className='flex'>
                    <div className='w-full'>
                        <div className='orgAccountGrid'>
                            <FormContent
                                id='orgExtraStyle'
                                label='TrvTo Website'
                                answer={`${accDetails?.webCom ?? 0}%`}
                                className='borderNone width50'
                            />
                            <FormContent
                                id='orgExtraStyle'
                                label='Organizer Website'
                                answer={`${accDetails?.orgWeb ?? 0}%`}
                                className='borderNone width50'
                            />
                        </div>
                        <div className='orgAccountGrid'>
                            <FormContent
                                id='orgExtraStyle'
                                label='Others Website'
                                answer={`${accDetails?.othWeb ?? 0}%`}
                                className='borderNone width50'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccPercentage;
